import { IFilters } from "./Fetch";
import IFile from "./File";
import Organisation from "./Organisation";
import { ISelectOption } from "./Select";
import UserCommission from "./UserCommission";

export type UserRoleType =
  | "SUPERADMIN"
  | "ADMIN"
  | "CSM"
  | "AE"
  | "SDR"
  | "HEADOFSALES"
  | "GENERALMANAGER";

export const USER_ROLES: ISelectOption<UserRoleType>[] = [
  { value: "SUPERADMIN", label: "Super administrateur" },
  { value: "ADMIN", label: "Administrateur" },
  { value: "CSM", label: "CSM" },
  { value: "AE", label: "Commercial" },
  { value: "SDR", label: "Télépro" },
  { value: "HEADOFSALES", label: "Responsable commercial" },
  { value: "GENERALMANAGER", label: "Directeur général" },
];

// Seuls SDR et AE ont une commission paramétrable.
export const COMMISSION_ROLES: UserRoleType[] = ["SDR", "AE"];

interface User {
  id: string;
  avatarId: string | null;
  avatar: IFile | null;
  signatureFileId: string | null;
  signatureFile: IFile | null;
  organisationId: string | null;
  organisation: Organisation | null;
  firstname: string;
  lastname: string;
  fullname: string;
  roles: UserRoleType[];
  email: string;
  phone: string | null;
  commissions: UserCommission[];
  isActive: boolean;
  isVeteran: boolean;
  cursorsEnabled: boolean;
  availabilitySetAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UserForm {
  avatar?: File | null;
  signatureFile?: File | null;
  firstname: string;
  lastname: string;
  roles: ISelectOption<UserRoleType>[];
  headOfSalesCommission?: number | null;
  email: string;
  password?: string;
  phone?: string | null;
  isVeteran?: boolean;
  isActive?: boolean;
  organisation?: Organisation | null;
}

export interface UserFormSend extends Omit<UserForm, "roles" | "organisation"> {
  roles: UserRoleType[];
  organisationId?: string | null;
}

export interface UserUpdateForm extends Partial<UserForm> {
  oldPassword?: string;
  newPassword?: string;
  newPasswordConfirmation?: string;
}

export interface UserUpdateFormSend extends Partial<UserFormSend> {
  oldPassword?: string;
  newPassword?: string;
  newPasswordConfirmation?: string;
}

export interface UserFilters extends IFilters {
  roles?: UserRoleType[];
  excludeIds?: string[];
  isActive?: boolean;
  excludeImported?: boolean;
}

export default User;
